import React, { FC } from 'react';
import { type IconV2Props } from '../../IconV2';
import getDataIconAttribute from '../../helpers/getDataIconAttribute';
import s from '../../IconV2.scss';

const ReceiptlessReturns120: FC<IconV2Props> = ({ icon, chroma }) => (
  <svg
    className={chroma === 'light' ? s.darkFill : s.lightFill}
    width="120"
    height="120"
    viewBox="0 0 120 120"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    data-icon={getDataIconAttribute(chroma, icon, '120')}
  >
    <g transform="translate(13.875000, 21.937500)" fillRule="nonzero">
      <polygon
        id="Path"
        points="28.875 0.375 28.875 22.5 31.125 22.5 31.125 2.625 73.875 2.625 73.875 73.875 31.125 73.875 31.125 49.5 28.875 49.5 28.875 76.125 76.125 76.125 76.125 0.375"
      />
      <path
        d="M39.9,45.135 L38.535,41.445 C35.475,33.21 27.93,27.57 19.125,26.85 L19.125,14.925 L0.63,33.345 L19.125,51.765 L19.125,38.37 C28.77,36.615 36.705,42.66 36.795,42.72 L39.9,45.135 Z M17.745,36.36 L16.875,36.555 L16.875,46.35 L3.825,33.345 L16.875,20.34 L16.875,28.995 L17.955,29.04 C25.035,29.295 31.32,33.045 34.815,38.88 C31.17,36.99 24.9,34.725 17.745,36.36 Z"
        id="Shape"
      />
      <rect id="Rectangle" x="45" y="31.875" width="15" height="2.25" />
      <rect id="Rectangle" x="45" y="42.375" width="15" height="2.25" />
      <rect id="Rectangle" x="45" y="21.375" width="15" height="2.25" />
      <rect id="Rectangle" x="45" y="52.875" width="15" height="2.25" />
    </g>
  </svg>
);

export default ReceiptlessReturns120;
